import {
  CreateOrganisationDto,
  GetValuesParams,
  UpdateOrganisationDto,
} from '../types/dto';
import { ListOrganisationResponse } from '../types/organisations';
import { Organization, ValuesResponse } from '../types/values';

import {
  formatFilters,
  Filters,
  privateClient,
  handleRequest,
  MultisectActionDto,
} from '@data-access';

type UpdateOneArgs = {
  id: number;
  data: UpdateOrganisationDto;
};

export const organisationApi = {
  getAll: (filters: Filters) => {
    return privateClient
      .get('organizations/', {
        searchParams: {
          ...formatFilters(filters),
        },
      })
      .json<ListOrganisationResponse>();
  },
  getOneById: (id: number) => {
    return privateClient.get(`organizations/${id}/`).json<Organization>();
  },
  deleteOne: (id: number) => {
    return privateClient.delete(`organizations/${id}/`).json();
  },
  deleteMany: (data: MultisectActionDto) => {
    return privateClient.delete(`organizations/bulk_delete/`, {
      json: data,
    });
  },
  createOne: (account: CreateOrganisationDto) => {
    return handleRequest<Organization>(
      privateClient
        .post(`organizations/`, {
          json: account,
        })
        .json(),
    );
  },
  updateOne: ({ id, data }: UpdateOneArgs) => {
    return handleRequest<Organization>(
      privateClient
        .patch(`organizations/${id}/`, {
          json: data,
        })
        .json(),
    );
  },

  getValues: async (params: GetValuesParams) => {
    const res = await privateClient
      .get(`organizations/values/`, {
        searchParams: params,
      })
      .json<ValuesResponse>();

    const countries = () => {
      if (!res.countries) return [];
      const options = Object.entries(res.countries);
      return options.map(([value, label]) => ({ value, label }));
    };

    const organization = res.organization?.map(({ id, name }) => ({
      value: id.toString(),
      label: name,
    }));

    const module = res.module?.map(({ id, name }) => ({
      value: id.toString(),
      label: name,
    }));

    const role = res.role?.map(({ id, name }) => ({
      value: id.toString(),
      label: name,
    }));

    return {
      ...res,
      countries: countries(),
      organization,
      module,
      role,
    };
  },
};
